import moment from "moment";
import {useEffect, useState} from "react";

import {IPFactory} from "../../models/IPFactory";

//redux
import {useDispatch, useSelector} from "react-redux";
import {
  createFactoryAction,
  // deleteFactoryAction,
  currentFactoryAction,
  deleteFactory,
  getFactoryList,
  modifyFactoryAction,
} from "../../features/sliceReducer/factoryListReducer";
import {alertsConfirmAction, modalOpenAction} from "../../features/sliceReducer/interactionReducer";
import {RootState} from "../../features/store";

//import Component
import ErrorControlled from "../../components/ErrorControlled";
import ListTitle from "../../components/ListTitle";
import PaginationControlled from "../../components/PaginationControlled";

// material-UI
import {createStyles, makeStyles, Theme, useTheme, withStyles} from "@material-ui/core/styles";

import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FactoryModalForm from "./FactoryModalForm";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },
  })
);

const FactoryList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const darkMode = useSelector((state: RootState) => state.theme.darkMode);
  console.log("⚾ ~ App ~ darkMode:", darkMode);
  const {userToken, user} = useSelector((state: RootState) => state.auth);

  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [factory, setFactory] = useState<IPFactory>({} as IPFactory);
  const theme = useTheme();

  console.log(theme.palette.primary.main);
  const {
    factoryList,
    loading,
    error,
    maxPage,
    message,
    tableHeader: factoryTableHeader,
  } = useSelector((state: RootState) => state.factoryList);

  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (keyword === undefined) dispatch(getFactoryList({userToken, searchWord, page}));
    else dispatch(getFactoryList({userToken, searchWord: keyword, page}));
  };

  const createFactory = () => {
    dispatch(createFactoryAction());
    dispatch(modalOpenAction());
  };

  useEffect(() => {
    dispatch(getFactoryList({userToken}));
  }, [userToken, message]);

  return (
    <Box>
      {/* <Loading loading={loading} /> */}
      <ErrorControlled error={error} />
      {/* <AlertsDialog /> */}
      <FactoryModalForm />
      <ListTitle
        setSearchWord={setSearchWord}
        searchDispatcher={searchDispatcher}
        page={page}
        subTitle={"Factory List"}
        buttonTitle={"사업장추가"}
        modal={createFactory}
      ></ListTitle>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              {factoryTableHeader.map((headerTitle, index) => (
                <TableCell key={index} align="center">
                  {headerTitle}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {factoryList?.map((factory, index) => {
              const isEnableDelete = factory.creatorUID === user.uid;
              return (
                <StyledTableRow key={factory.uid}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {factory.uid}
                  </TableCell>
                  <TableCell align="left">{factory.name}</TableCell>
                  <TableCell align="center">{factory.initial}</TableCell>
                  <TableCell align="left">{factory.description}</TableCell>
                  <TableCell align="center">
                    <img
                      style={{height: "30px"}}
                      src={`/uploads/inspect/companyLogo/${factory.logoFile}`}
                      alt={factory.initial}
                    />
                  </TableCell>
                  <TableCell align="center">{factory.creatorName}</TableCell>
                  <TableCell align="center">
                    {moment(factory.entryDate).format("YYYY년 MM월 DD일")}
                  </TableCell>
                  <TableCell align="center">
                    {moment(factory.modifyDate).format("YYYY년 MM월 DD일")}
                  </TableCell>
                  <TableCell className={classes.buttonCell}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<EditIcon />}
                      onClick={() => {
                        dispatch(currentFactoryAction(factory));
                        dispatch(modifyFactoryAction());
                        dispatch(modalOpenAction());
                        console.log(factory);
                      }}
                    >
                      편집
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DeleteIcon />}
                      disabled={!isEnableDelete}
                      onClick={() => {
                        dispatch(
                          alertsConfirmAction({
                            alertContent: "해당사업장을 삭제하시겠습니까?",
                            // alertAction: deleteFactoryAction(factory.uid),
                            alertAction: deleteFactory({userToken, id: factory.uid}),
                          })
                        );
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationControlled
        page={page}
        maxPage={maxPage}
        pageChange={(page: number) => searchDispatcher(page, searchWord)}
      />
    </Box>
  );
};

export default FactoryList;
